import { render, staticRenderFns } from "./panel-navigation.vue?vue&type=template&id=c6874962&"
import script from "./panel-navigation.vue?vue&type=script&lang=js&"
export * from "./panel-navigation.vue?vue&type=script&lang=js&"
import style0 from "./panel-navigation.vue?vue&type=style&index=0&id=c6874962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports